<template>
  <div
    class="home-background"
    :style="{ backgroundImage: `url(${mainBackground})` }"
  >
    <div class="home-title text-h3">
      <!-- PC(데스크톱) 전용 텍스트 -->
      <div class="desktop-only">
        아트 & 테크 협업할 때 <br />
        최악의 예술가/기술자 유형 월드컵
      </div>

      <!-- 모바일 전용 텍스트 -->
      <div class="mobile-only">
        아트 & 테크 <br />
        협업할 때 <br />
        최악의 <br />
        예술가/기술자 <br />
        유형 월드컵
      </div>
    </div>
  </div>
</template>

<script>
import mainBackground from "@/assets/img/main.png";

export default {
  name: "HomePage",
  data() {
    return {
      mainBackground,
    };
  },
};
</script>

<style scoped>
/* 배경 스타일 */
.home-background {
  position: relative;
  width: 100%;
  height: 93vh;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}

/* 공통 타이틀 스타일 */
.home-title {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-weight: 500;
  text-align: center;
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
}

/* 
  PC 기본 폰트 사이즈. 
  (원하는 값으로 자유롭게 조정)
*/
.home-title.text-h3 {
  font-size: 1.5rem;
  line-height: 1.3;
}

/* 
  PC일 때는 데스크톱 전용 텍스트만 보이고, 
  모바일 전용 텍스트는 숨김 
*/
.desktop-only {
  display: block;
}
.mobile-only {
  display: none;
}

/* 
  600px 이하(모바일)에서:
    1) PC 텍스트 숨기기
    2) 모바일 텍스트 보이기
    3) 폰트 사이즈도 모바일용으로 조정
*/
@media (max-width: 600px) {
  .desktop-only {
    display: none;
  }
  .mobile-only {
    display: block;
  }

  .home-title.text-h3 {
    font-size: 2rem !important; /* 원하는 모바일용 폰트 크기로 */
    line-height: 1.4;
  }
}
</style>
